import {ClanTask} from "~/Actions/ActionClanTasks";

export const getClaimedTasks = (tasks: Array<ClanTask>) => tasks.filter((task: ClanTask) => task.isClaimed)

export const areAllTasksClaimed = (tasks: Array<ClanTask>) => tasks.every((task: ClanTask) => task.isClaimed)

export const lastTaskClaimedAt = (tasks: Array<ClanTask>) => {
  const sorted = tasks.sort((a, b) => new Date(a.claimedAt).getTime() - new Date(b.claimedAt).getTime())
  return new Date(sorted[sorted.length - 1].claimedAt).getTime()
}

const WEEK = 7 * 24 * 60 * 60 * 1000

export const shouldHideTasksNav = (tasks: Array<ClanTask>, length: number = null) => {
  const necessaryCondition = areAllTasksClaimed(tasks)
  const claimedTasksCount = !length || getClaimedTasks(tasks).length === length
  const sufficientCondition = claimedTasksCount && new Date().getTime() - lastTaskClaimedAt(tasks) > WEEK
  return tasks.length === 0 || (necessaryCondition && sufficientCondition)
}
